module.exports = __webpack_public_path__ + "img/logo-wordpress-woocommerce.c518d2cb.png";